import { QSetStatus } from '@exam-management/graphql';
import { dataGridSortDirection } from '@shared/components';
import { parseAsPageNumber } from '@shared/utils';
import { parseAsString, parseAsInteger, parseAsStringLiteral, useQueryStates } from 'nuqs';

// TODO: Consider Promote this to @shared/utils
type SortOrder = (typeof dataGridSortDirection)[number];

export function useQSetListSearchParams() {
  const [{ status, page, pageSize, sortOrder, sortBy }, setQueryParams] = useQueryStates({
    status: parseAsStringLiteral(Object.values(QSetStatus)).withDefault(QSetStatus.Draft),
    page: parseAsPageNumber.withDefault(0),
    pageSize: parseAsInteger.withDefault(10),
    sortOrder: parseAsStringLiteral(dataGridSortDirection).withDefault('desc'),
    sortBy: parseAsString.withDefault('updatedAt'),
  });

  const changePageNumber = (page: number) => {
    setQueryParams({ page });
  };

  const changeStatus = (status: QSetStatus) => {
    setQueryParams({ status, page: 0, sortOrder: null });
  };

  const changePageSize = (pageSize: number) => {
    setQueryParams({ pageSize, page: 0 });
  };

  const changeSorting = ({
    sortOrder,
    sortBy,
  }: {
    sortOrder: SortOrder | null;
    sortBy: string | null;
  }) => {
    setQueryParams({ sortOrder, page: 0, sortBy });
  };

  return [
    {
      status,
      page,
      pageSize,
      sortOrder,
      sortBy,
    },
    { changePageNumber, changePageSize, changeStatus, changeSorting },
  ] as const;
}
